import { Typography } from '@navi/web-ui/lib/primitives';
import cx from 'classnames';
import { HistoryColDefCell } from '../../constants/types';

export const renderContent = (radioOption: string) => {
  switch (radioOption) {
    case HistoryColDefCell.ALL:
      return (
        <div className="flex flex-col justify-around">
          <Typography variant="p4" className="px-[12px] pt-[-5px] pb-[10px]">
            Login Time
          </Typography>
          <div className="w-[100%] h-[1px] bg-greyscale-light" />
          <Typography variant="p4" className="px-[12px] py-[12px]">
            Logout Time
          </Typography>
          <div className="w-[100%] h-[1px] bg-greyscale-light" />
          <Typography variant="p4" className="px-[12px] py-[12px]">
            First Call Time
          </Typography>
          <div className="w-[100%] h-[1px] bg-greyscale-light" />
          <Typography variant="p4" className="px-[12px] py-[12px]">
            Break Hrs
          </Typography>
          <div className="w-[100%] h-[1px] bg-greyscale-light" />
          <Typography variant="p4" className="px-[12px] py-[10px]">
            Active Hrs
          </Typography>
        </div>
      );
    case HistoryColDefCell.LOGIN_TIME:
      return (
        <Typography variant="p4" className="px-[12px] pb-[10px]">
          Login Time
        </Typography>
      );
    case HistoryColDefCell.LOGOUT_TIME:
      return (
        <Typography variant="p4" className="px-[12px] py-[10px]">
          Logout Time
        </Typography>
      );
    case HistoryColDefCell.FIRST_CALL_TIME:
      return (
        <Typography variant="p4" className="px-[12px] py-[10px]">
          First Call Time
        </Typography>
      );
    case HistoryColDefCell.ACTIVE_HRS:
      return (
        <Typography variant="p4" className="px-[12px] py-[10px]">
          Active Hrs
        </Typography>
      );
    case HistoryColDefCell.BREAK_HRS:
      return (
        <Typography variant="p4" className="px-[12px] py-[10px]">
          Break Hrs
        </Typography>
      );
    default:
      return (
        <Typography variant="p4" className="px-[12px] py-[10px]">
          Active Hrs
        </Typography>
      );
  }
};

export const rowClass = (applyRed = false) =>
  cx({
    'text-red-base': applyRed,
    'px-[12px] py-[10px]': true
  });
